














































import ContactSelect from "./ContactSelect.vue";
import TextInput from "./TextInput.vue";
import HtmlTextareaInput from "./HtmlTextareaInput.vue";
import { Contact } from "../../models/Contact";
import CoordonneeSelector from "../../notifications/AbsenceNotificationModalPartials/CoordonneeSelector.vue";
export default {
    name: "MailEditor",
    components: {
        CoordonneeSelector,
        HtmlTextareaInput,
        TextInput,
        ContactSelect,
    },
    props: {
        mailData: Object,
        multiBody: Boolean,
        hideRecipients: Boolean,
        defaultContact: Contact,
        preSelectRole: Contact.ERole,
    },
    data() {
        return {
            mailEditing: {},
            selectedContact: null,
            selectedMails: "",
        };
    },
    created() {
        if (this.defaultContact) {
            this.selectedContact = this.defaultContact;
        }
    },
    watch: {
        selectedContact: function () {
            if (!_.isNull(this.selectedContact)) {
                this.mailEditing.to = "";
                this.mailEditing.recipient = this.selectedContact;
            }
        },
        selectedMails: function () {
            this.mailEditing.to = this.selectedMails;
        },
        mailEditing: {
            deep: true,
            handler: function () {
                if (this.multiBody) {
                    this.mailEditing.body = _.reduce(
                        this.mailEditing.bodies,
                        (acc, body) => {
                            return acc + body.text;
                        },
                        ""
                    );
                }
                this.$emit("updated-mail", this.mailEditing);
            },
        },
        mailData: {
            immediate: true,
            deep: true,
            handler: function () {
                this.mailEditing = _.clone(this.mailData);
            },
        },
    },
};
